import React, { useState } from "react";
import Hero from "../../Components/HeroComponent/Hero";
import WhySolar from "../../Components/WhySolar/WhySolar";
import OurServices from "../../Components/OurServices/OurServices";
import HowItWorks from "../../Components/HowItWorks/HowItWorks";
import Testimonials from "../../Components/Testimonials/Testimonials";
import Location from "../../Components/Location/Location";
import OurExperience from "../../Components/OurExperience/OurExperience";
import styles from "./HomePage.module.css";

const HomePage = () => {
  return (
    <>
      <Hero />
      <WhySolar />
      <OurExperience />
      <OurServices />
      <HowItWorks />
      <Testimonials />
      <Location />
    </>
  );
};

export default HomePage;
